// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1C61k","col":"Table_col__xJNol","fulfillmentStatus":"Table_fulfillmentStatus__31sf7","emailCol":"Table_emailCol__D2oBG"};